import RisebinarRepository from "@repositories/risebinar.repository"
import { Result } from "./result"
import { Category } from "@interfaces/category"
import { PaginationData } from "@interfaces/misc"
import { Risebinar } from "@interfaces/risebinar"

export interface RisebinarQuery {
  time?: "today" | "this_week" | "next_week" | "this_month" | "next_month" | "upcoming"
  category?: Category
  search: string
  page: number
  limit: number
}

interface LinkResponse {
  status: string
  link: {
    id: number
    title: string
    hash: string
    alias: string
    long_url: string
    short_url: string
    disabled: false
    expires_at: Date
    description: string
    type: string
    clicks_count: number
    expiration_clicks: number
    utm: string
    has_password: boolean
  }
}

export default class RisebinarServices extends RisebinarRepository {
  async getRisebinarList(query?: Partial<RisebinarQuery>) {
    try {
      const res = await this.getRawRisebinarList(query)
      const response = await this._getResponse<PaginationData<Risebinar>>(res)

      if (response.error || !response.result) {
        return Result.fail<PaginationData<Risebinar>>()
      }

      const result = response.result as any

      if (!result) {
        return Result.fail<PaginationData<Risebinar>>()
      }

      return Result.ok<PaginationData<Risebinar>>(response.result)
    } catch (e) {
      return Result.fail<PaginationData<Risebinar>>()
    }
  }

  async getRisebinarShareLink(risebinarSlug: string) {
    try {
      const res = await this.getRawRisebinarLink({
        long_url: `${
          process.env.API_ENDPOINT || process.env.HARISENIN_API_ENDPOINT
        }/risebinar/${risebinarSlug}`,
        type: "direct",
        active: true,
      })

      if (res.ok) {
        const body = (await res.json()) as LinkResponse
        return Result.ok<string>(body.link.short_url)
      } else {
        return Result.fail<string>()
      }
    } catch (e) {
      throw { message: "Terjadi kesalahan. Silahkan coba lagi" }
    }
  }
}
